import { THEMES, useTheme } from '../../theme/ThemeContext';

export function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();

    let icon = '🌙';
    let label = 'Dark';
    let nextLabel = 'Switch to light theme';

    if (theme === THEMES.LIGHT) {
        icon = '☀️';
        label = 'Light';
        nextLabel = 'Switch to minimalist theme';
    } else if (theme === THEMES.MINIMALIST) {
        icon = '🔳';
        label = 'Minimal';
        nextLabel = 'Switch to dark theme';
    }

    return (
        <button
            type='button'
            className='theme-toggle'
            onClick={toggleTheme}
            aria-label={nextLabel}
        >
            <span aria-hidden='true'>{icon}</span>
            <span>{label}</span>
        </button>
    );
}

export default ThemeToggle;
